import { CheckboxItem, ItemIndicator } from '@radix-ui/react-context-menu'
import { IconCheck } from '@tabler/icons-react'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export interface ContextMenuCheckboxItemProps extends ComponentPropsWithoutRef<
  typeof CheckboxItem
> {
  asChild?: boolean
  checked?: boolean | 'indeterminate'
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  onSelect?: (event: Event) => void
  textValue?: string
  /**
   * [data-state] - "checked" | "unchecked" | "indeterminate"
   * [data-highlighted] - Present when highlighted
   * [data-disabled] - Present when disabled
   */
  className?: string
}

export const ContextMenuCheckboxItem = forwardRef<
  ElementRef<typeof CheckboxItem>,
  ContextMenuCheckboxItemProps
>(({ className, children, checked, ...props }, ref) => (
  <CheckboxItem
    ref={ref}
    className={cn(
      'relative flex cursor-default select-none items-center rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      className
    )}
    checked={checked}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <ItemIndicator>
        <IconCheck className="size-4" />
      </ItemIndicator>
    </span>
    {children}
  </CheckboxItem>
))
ContextMenuCheckboxItem.displayName = CheckboxItem.displayName
